/**
 * @generated SignedSource<<8af2268a73377d2400b01a52a8b53e56>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Article_article$data = {
  readonly articleContent: {
    readonly " $fragmentSpreads": FragmentRefs<"ArticleContent_articleContent">;
  } | null | undefined;
  readonly content: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"ArticleContentOld_content">;
  } | null | undefined> | null | undefined;
  readonly id: string;
  readonly title: string | null | undefined;
  readonly url: string | null | undefined;
  readonly " $fragmentType": "Article_article";
};
export type Article_article$key = {
  readonly " $data"?: Article_article$data;
  readonly " $fragmentSpreads": FragmentRefs<"Article_article">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Article_article",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "content",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ArticleContentOld_content"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpCenterArticleModelArticleContentField",
      "kind": "LinkedField",
      "name": "articleContent",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ArticleContent_articleContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HelpCenterArticleRecord",
  "abstractKey": null
};

(node as any).hash = "50eae434054e48eb3bf0e45095e474e4";

export default node;
